"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faHandPointUp = require("@fortawesome/pro-regular-svg-icons/faHandPointUp");

var _core = require("@chakra-ui/core");

var _polished = require("polished");

var _peractoConfig = require("@peracto/peracto-config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function hexToRgbA(hex) {
  var c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');

    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = '0x' + c.join('');
    return 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',0.3)';
  }

  return 'rgba(0,0,0,0.3)';
}

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    py: 10,
    justifyContent: "center",
    alignItems: "center",
    w: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faHandPointUp.faHandPointUp,
    size: "6x"
  }));
};

var ButtonsComponent = function ButtonsComponent(_ref) {
  var _window, _window$location;

  var _ref$state = _ref.state,
      _ref$state$buttons = _ref$state.buttons,
      buttons = _ref$state$buttons === void 0 ? [] : _ref$state$buttons,
      _ref$state$direction = _ref$state.direction,
      direction = _ref$state$direction === void 0 ? 'row' : _ref$state$direction,
      _ref$state$justifyCon = _ref$state.justifyContent,
      justifyContent = _ref$state$justifyCon === void 0 ? 'flex-start' : _ref$state$justifyCon,
      _ref$state$spacing = _ref$state.spacing,
      spacing = _ref$state$spacing === void 0 ? 10 : _ref$state$spacing,
      _ref$state$selectedBu = _ref$state.selectedButtonIndex,
      selectedButtonIndex = _ref$state$selectedBu === void 0 ? null : _ref$state$selectedBu,
      isEditMode = _ref.isEditMode,
      onChange = _ref.onChange,
      focused = _ref.focused;
  var config = (0, _peractoConfig.useConfig)();
  var editorConfig = config.get('editorConfig');
  var buttonVariants = editorConfig === null || editorConfig === void 0 ? void 0 : editorConfig.buttonVariants;
  var hoverFactor = 0.03;
  var activeFactor = 0.05;
  var lightenFactor = 0.9;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_core.Flex, {
    direction: direction,
    justifyContent: direction === 'row' && justifyContent,
    alignItems: direction === 'column' && justifyContent,
    className: "content__buttons"
  }, buttons.map(function (button, idx) {
    var _buttonVariants$butto;

    var hoverColor = buttonVariants && button.variant && buttonVariants !== null && buttonVariants !== void 0 && buttonVariants[button.variant].accentColor ? {
      _hover: {
        textDecoration: 'none',
        color: "white",
        bg: button.isDark ? (0, _polished.lighten)(0.15, buttonVariants[button.variant].accentColor) : (0, _polished.darken)(0.05, buttonVariants[button.variant].accentColor)
      },
      _active: {
        bg: button.isDark ? (0, _polished.lighten)(0.18, buttonVariants[button.variant].accentColor) : (0, _polished.darken)(0.08, buttonVariants[button.variant].accentColor)
      }
    } : {};
    return /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
      key: "btn_".concat(Math.floor(Math.random() * 10000)),
      className: "content__button",
      href: button.url,
      as: "a",
      boxShadow: selectedButtonIndex === idx && focused && 'inset 0 0 0 3px yellow'
    }, buttonVariants !== null && buttonVariants !== void 0 && buttonVariants[button.variant] ? _objectSpread({}, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, buttonVariants[button.variant]["sharedProps"]), button.style === "solid" && _objectSpread(_objectSpread({
      bg: buttonVariants[button.variant].accentColor
    }, hoverColor), buttonVariants[button.variant].solidProps)), button.style === "outline" && _objectSpread(_objectSpread(_objectSpread({}, hoverColor), {}, {
      color: buttonVariants[button.variant].accentColor,
      borderColor: buttonVariants[button.variant].accentColor
    }, buttonVariants[button.variant].outlineProps), {}, {
      boxShadow: selectedButtonIndex === idx && focused ? 'inset 0 0 0 3px yellow' : ((_buttonVariants$butto = buttonVariants[button.variant].outlineProps) === null || _buttonVariants$butto === void 0 ? void 0 : _buttonVariants$butto.boxShadow) || "inset 0 0 0 2px ".concat(buttonVariants[button.variant].accentColor)
    })), button.style === "ghost" && _objectSpread(_objectSpread({}, hoverColor), buttonVariants[button.variant].ghostProps)), button.style === "link" && _objectSpread({
      padding: '',
      _active: {
        color: (0, _polished.darken)(0.05, buttonVariants[button.variant].textColor)
      }
    }, buttonVariants[button.variant].linkProps))) : {
      color: button.style !== 'solid' && button.colour || button.textColour,
      bg: button.style === 'solid' ? button.colour : 'transparent',
      border: button.style === 'outline' ? "3px solid ".concat(button.colour) : 'none',
      borderWidth: button.style === 'solid' && '0px',
      _hover: {
        backgroundColor: button.style === 'outline' ? hexToRgbA(button.colour || '#000000') : button.style === 'solid' ? (0, _polished.darken)(hoverFactor, button.colour) : (0, _polished.lighten)(lightenFactor, button.colour),
        color: button.style === 'solid' ? button.textColour : button.colour,
        textDecoration: 'none'
      },
      _active: {
        bg: button.style === 'solid' ? (0, _polished.darken)(activeFactor, button.colour) : (0, _polished.lighten)(lightenFactor, button.colour)
      }
    }, {
      size: button.size,
      w: button.width === 'full' ? '100%' : 'auto',
      ml: idx > 0 && direction === 'row' && !['space-between', 'space-around'].includes(justifyContent) ? "".concat(spacing, "px") : 0,
      mt: idx > 0 && direction === 'column' && !['space-between', 'space-around'].includes(justifyContent) ? "".concat(spacing, "px") : 0,
      _disabled: {
        opacity: 0.8,
        cursor: 'not-allowed'
      },
      onClick: function onClick(e) {
        if (isEditMode) {
          e.preventDefault();
          onChange({
            selectedButtonIndex: idx
          });
        }
      }
    }, button.openInNewTab && {
      target: '_blank'
    }), button.label);
  })) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var _default = ButtonsComponent;
exports["default"] = _default;